import { Croppie } from 'croppie'

function dispatchChange(element) {
  if ("createEvent" in document) {
    var evt = document.createEvent("HTMLEvents")
    evt.initEvent("change", false, true)
    element.dispatchEvent(evt)
  } else {
    element.fireEvent("onchange")
  }
}

Croppie.prototype.updateZoom = function(val) {
  this.elements.zoomer.value = parseFloat(this.elements.zoomer.value) + val
  dispatchChange(this.elements.zoomer)
}

Croppie.prototype.setMaxZoom = function(zoom) {
  this.options.maxZoom = zoom
}

export default Croppie